import axios from "axios";
import * as Config from "../../config/config";
import * as Tools from "../utils/tools";
import * as Dialog from "../utils/dialog";
import * as Cache from "../utils/cache";
import Auth from "@/assets/utils/auth";
import {
    debounce
} from "./dbucTrtl";

// 配置http
let http = axios.create({
    baseURL: Config.API_BASE_URL,
    timeout: 5000,
    custom: {
        isAuth: true,
        isLoading: true,
        isErrorMsg: true,
        isTimeout: false,
    }
});

// 添加请求拦截器
http.interceptors.request.use(function (config) {
    if (Tools.empty(config.params)) config.params = {}

    // token
    if (config.custom.isAuth) {
        let token = Cache.get('token');
        if (!Tools.empty(token)) config.headers.Authorization = token;
    }
    // 判断参数是否需要长时间接口相应
    if (config.custom.isTimeout) {
        config.timeout = Config.INTERFACE_TIMEOUT;
    }

    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    let config = response.config;
    let res = response.data;
    if (!Tools.empty(res.code) && res.code != 200) {
        switch (res.code) {
            case '20005':
                debounceLogin()
                break;
            case '20004':
                debounceLogin()
                break;
            case '910101':
                break
            default:
                if (config.custom.isErrorMsg) {
                    Dialog.toast(res.message, {
                        type: 'error'
                    });
                }
        }
        return Promise.reject(response);
    } else {
        return response;
    }
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

// 防抖处理多接口token校验弹框过多的问题
const debounceLogin = debounce(() => {
    Dialog.toast('登录失效，请重新登录', {
        type: 'error'
    });
    Auth.logout();
}, 800, false);

// 添加文件上传方法（带进度监听）
http.uploadWithProgress = function (url, data, onUploadProgress, config = {}) {
    // 合并配置
    const mergedConfig = {
        ...config,
        onUploadProgress: onUploadProgress,
        headers: {
            'Content-Type': 'multipart/form-data',
            ...config.headers
        }
    };

    return this.post(url, data, mergedConfig);
};

export {
    http as http
}